import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { 
  Home, 
  Search, 
  BookOpen, 
  User,
  Heart
} from 'lucide-react';

export default function MobileBottomNav() {
  const { user } = useAuth();
  const location = useLocation();

  // Hide on reader page for immersive reading
  const hideOnRoutes = ['/read/'];
  const shouldHide = hideOnRoutes.some(route => location.pathname.startsWith(route));

  const isActive = (path) => {
    if (path === '/home') return location.pathname === '/home' || location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  const navItems = [
    { path: '/home', label: 'Início', icon: Home },
    { path: '/browse', label: 'Contos', icon: Search },
    { path: '/favorites', label: 'Favoritos', icon: Heart },
    { path: '/conhece-te', label: 'Conhece', icon: BookOpen },
    { path: '/profile', label: 'Perfil', icon: User },
  ];

  if (!user || shouldHide) return null;

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-surface/95 backdrop-blur-lg border-t border-border" style={{ paddingBottom: 'env(safe-area-inset-bottom, 0)' }}>
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          return (
            <Link
              key={item.path}
              to={item.path}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
              className={`flex flex-col items-center justify-center flex-1 h-full min-w-0 px-1 transition-colors active:scale-95 ${
                active 
                  ? 'text-ruby' 
                  : 'text-muted-foreground'
              }`}
            >
              <Icon className={`w-5 h-5 shrink-0 ${active ? 'stroke-[2.5]' : ''}`} />
              <span className={`text-[10px] mt-1 leading-none truncate w-full text-center ${active ? 'font-semibold' : 'font-medium'}`}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
